<div style="position:fixed; z-index:9999; top:0px;left:0;height:100%;width:100%;background:rgba(0, 0, 0, 0.8)">
  <div class="well clearfix" style="position:relative; margin:0 auto; top:10px; height: 300; width:300px;">
    <div class="row">
      <div class="col-xs-12">
        <label>{{ 'weblink.edit.status' | translate }}</label><label style="color: red">*</label>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <select class="form-control" name="status" [(ngModel)]="fault.newStatus">
          <option value="" disabled selected hidden>{{ 'weblink.edit.status' | translate }}</option>
          <option *ngFor="let s of status" [ngValue]="s">{{s.Name1}} - {{s.Name2}}</option>
        </select>
      </div>
    </div>
    <div class="row margin-top">
      <div class="col-xs-12">
        <label>{{ 'weblink.edit.remarks' | translate }}</label><label *ngIf="settings.IsDescriptionRequired" style="color: red">*</label>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <textarea [maxlength]="4000-currentUser.length-3" name="text" rows="3" class="form-control" placeholder="{{ 'weblink.edit.remarks' | translate }}" style="resize: none;" [(ngModel)]="fault.newText" ></textarea>
      </div>
    </div>

    <div class="row margin-top" style="padding-left: 15px; padding-right: 15px">
      <div class="col-xs-0">
        <label>{{ 'weblink.edit.files' | translate }}</label><label *ngIf="settings.IsAttachmentRequired" style="color: red">*</label>
      </div>

      <div *ngIf="(fault.newFiles?.length ?? 0) < (multipleAttachmentsEnabled ? 5 : 1)" class="row" style="margin-right: 8px; width: 40px">
        <div class="col-xs-3">
          <button type="button" class="btn btn-default" onclick="document.getElementById('file').click();">
            <span class="glyphicon glyphicon-camera"></span>
          </button>
        </div>
      </div>


      <div *ngFor="let newFile of fault.newFiles; let i = index">
        <div class="row margin-top">
          <div *ngIf="newFile" class="col-xs-3" style="margin-right: 8px; width: 40px">
            <button type="button" class="btn btn-default" [hidden]="!newFile" (click)="removeAttachment(i)">
              <span class="glyphicon glyphicon-trash"></span>
            </button>
          </div>
          <div class="col-xs-9" style="width: calc(100% - 48px)">
            <div *ngIf="newFile">
              <span style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap; display: block; width: 100%">{{newFile?.name}}</span>
            </div>
          </div>
        </div>

      </div>
      <input #myFile  type="file" id="file" style="display:none" [multiple]="multipleAttachmentsEnabled" (change)="addFiles($event)">
    </div>

    <div class="row double-margin-top">
      <div class="col-xs-12">
        <button type="button" class="btn btn-default" (click)="cancel()">
          <span class="glyphicon glyphicon-remove"></span>
          {{ 'weblink.button.cancel' | translate }} <span class="badge"></span>
        </button>
        <button type="button" class="btn btn-default" (click)="save()" [disabled]="fault.newStatus === null || (settings.IsDescriptionRequired && !fault.newText) || (settings.IsAttachmentRequired && (fault.newFiles?.length ?? 0) == 0)">
          <span class="glyphicon glyphicon-ok"></span>
          {{ 'weblink.button.save' | translate }}
        </button>
      </div>
    </div>

  </div>
</div>
